module.exports = __webpack_public_path__ + "static/img/3-4.16993381.jpg";